var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default').default;

(function () {
  Flint.file('mframework/views/motion.js', function (require) {
    var _reactMotion = require('react-motion');

    var _reactMotion2 = _interopRequireDefault(_reactMotion);

    var RMotion = _reactMotion2.default.Motion;
    var RStaggeredMotion = _reactMotion2.default.StaggeredMotion;
    var RTransitionMotion = _reactMotion2.default.TransitionMotion;
    var spring = _reactMotion2.default.spring;

    Flint.view('Motion', function (view, on, $) {
      var pro = initPro(view, {
        defaultStyle: M.mapAtom({}),
        style: M.mergeAtom()
      });

      var styleAtom = atom(pro.defaultStyle.get());

      var der = styleAtom.derive(function (styleMap) {
        return view.props.children(styleMap.toJS());
      });

      var elemFunc = function elemFunc(style) {
        styleAtom.set(immutable.fromJS(style));
        return der.get();
      };view.render(function () {
        return view.el(
          [RMotion, 'RMotion', 1],
          {
            defaultStyle: pro.defaultStyle.get().toJS(),
            style: pro.style.get().toJS()
          },
          (function () {
            der.get(); // Register derivable dependencies
            return elemFunc;
          })()
        );
      });
    });
    Flint.staticStyles('TransitionMotion', {
      '$wrapper': '#_flintapp wrapper.TransitionMotion, #_flintapp .TransitionMotion.wrapper, #_flintapp .ViewTransitionMotion.wrapper, #_flintapp .TransitionMotion > .wrapper'
    }, {
      '$wrapper': {
        position: 'relative'
      }
    });
    Flint.view('TransitionMotion', function (view, on, $) {
      var pro = initPro(view, {
        defaultStyles: M.mapAtom({}),
        styles: M.mapAtom(),
        willEnter: atom(),
        willLeave: atom()
      });

      var stylesAtom = atom(pro.defaultStyles.get());

      var der = stylesAtom.derive(function (stylesMap) {
        var ret = view.props.children(stylesMap.toJS());
        if (ret instanceof List || ret instanceof Array) {
          return view.el(
            ['wrapper', 1],
            null,
            ret
          );
        } else {
          return ret;
        }
      });

      var elemFunc = function elemFunc(styles) {
        stylesAtom.set(immutable.fromJS(styles));
        return der.get();
      };view.render(function () {
        return view.el(
          [RTransitionMotion, 'RTransitionMotion', 1],
          {
            defaultStyles: pro.defaultStyles.get().toJS(),
            styles: pro.styles.get().toJS(),
            willEnter: pro.willEnter.get(),
            willLeave: pro.willLeave.get()
          },
          (function () {
            der.get(); // Register derivable dependencies
            return elemFunc;
          })()
        );
      });
    });
  })
})();
//# sourceMappingURL=motion.js.map
